import type { ReactElement } from 'react';

/** Default cell renderer — formats a value by its zmodel field type. Override
 *  per-table via the `formatCell` prop, or per-column via `columnRenderers`.
 *  Return type is narrowed to `ReactElement | string` for tanstack-table v8
 *  (pinned against React 18's ReactNode). */
export function formatCell(value: unknown, fieldType: string): ReactElement | string {
  if (value == null) return <span className="text-muted-foreground">—</span>;

  switch (fieldType) {
    case 'DateTime':
      return <span title={String(value)}>{formatDate(value)}</span>;
    case 'Boolean':
      return value ? '✓' : '✗';
    case 'Int':
    case 'BigInt':
    case 'Float':
    case 'Decimal':
      return <span className="tabular-nums">{String(value)}</span>;
    case 'String':
      return <span>{String(value)}</span>;
    case 'Json':
      return <code className="text-xs">{JSON.stringify(value)}</code>;
    default:
      if (typeof value === 'object')
        return <code className="text-xs">{JSON.stringify(value)}</code>;
      return <span>{String(value)}</span>;
  }
}

function formatDate(v: unknown): string {
  const d = v instanceof Date ? v : new Date(v as string);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString();
}
